import { useState } from "react";
import { SectionTitle } from "../../PresentationalComponents/SectionTitle";
import styles from "./Projects.module.css";
import { useTranslation } from "react-i18next";
import { Section } from "./Section";
import projects from "../../../assets/data/projects";
import { Tag } from "../../PresentationalComponents/Tag";

const projectDictionary = {
  en: {
    text: "PROJECTS",
    num: "03",
    details: "From Concept to a Real Web Experience ",
  },
  fa: {
    text: "پروژه‌ها",
    num: "۰۳",
    details: "نگاهی کوتاه به فرایند طراحی و توسعه ",
  },
};

export function Projects({ t }) {
  const [openDetails, setOpenDetails] = new useState(false);
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const [visible, setVisible] = useState(true);
  const [projectPreview, setProjectPreview] = useState(0);

  function detailsRenderer(project) {
    return (
      <>
        <Section project={projects[projectPreview]} />
      </>
    );
  }

  return (
    <>
      <section
        id="Projects"
        className={
          visible
            ? styles.sectionContainer + " " + styles.fadeIn
            : styles.sectionContainer + " " + styles.fadeOut
        }
        name="Projects"
      >
        <div className={styles.header}>
          <SectionTitle
            text={projectDictionary[lang].text}
            num={projectDictionary[lang].num}
          />
        </div>
        <div className={styles.selectedProjectContainer}>
          <div className={styles.selectedProjectTextBox}>
            <h3>{projects[projectPreview][lang].header.title}</h3>
            <p>{projects[projectPreview][lang].header.intro}</p>
            <div className={styles.tagContainer}></div>
            <div className={styles.detailsSummaryBox}>
              <details
                className={styles.openButton}
                open={openDetails}
                onToggle={(el) => {
                  setOpenDetails(el.currentTarget.open);
                }}
              >
                <summary>{projectDictionary[lang].details}</summary>
              </details>
            </div>
          </div>

          <div className={styles.imageContainer}>
            <img
              src={projects[projectPreview][lang].header.image}
              alt={projects[projectPreview][lang].header.image.split("/")[-1]}
            />
          </div>
        </div>
        <div
          className={
            openDetails
              ? styles.detailsContainer + " " + styles.openDetails
              : styles.detailsContainer
          }
        >
          {detailsRenderer(projects[projectPreview])}
        </div>
      </section>
      <section
        className={styles.projectsContainer}
        style={projectPreview ? { scale: 1 } : {}}
      >
        {projects.map((project, index) => (
          <div
            className={styles.cardContainer}
            key={index}
            onClick={() => {
              setVisible(false);
              setTimeout(() => {
                setProjectPreview(index);

                setVisible(true);
              }, 1000);
            }}
          >
            <img
              src={project[lang].header.image}
              alt={project[lang].header.image.split("/")[-1]}
            />
            <div className={styles.cardTextBox}>
              <label>{project[lang].side.Date}</label>
              <h3>{project[lang].header.title}</h3>
              <div className={styles.tagContainer}>
                {project[lang].side.Technologies.split(" · ").map(
                  (tag, index) => {
                    if (index < 3) return <Tag text={tag} key={index} />;
                  },
                )}
              </div>
            </div>
          </div>
        ))}
      </section>
    </>
  );
}
